import React from "react"
import "./ResourceBanner.scss"
import ResourceBannerCompliance from "../ResourceBannerCompliance"
import ResourceBannerEntityDetail from "../ResourceBannerEntityDetail"
import HelpTooltip from "../HelpTooltip"
import PropTypes from "prop-types"

const ResourceBanner = ({
  entityName,
  entityType,
  compliance,
  opportunities,
  title,
  detailEntities,
  bsrCompliance,
}) => {
  return (
    <div>
      <div className="ResourceBanner">
        <div className="banner-title">
          <h1>{title || entityName}</h1>
          <span className="subname">
            {bsrCompliance
              ? "Bedside Shift Report Compliance"
              : "Nurse Rounding Compliance"}
          </span>
        </div>
        {detailEntities.length > 0 && (
          <ResourceBannerEntityDetail entities={detailEntities} />
        )}
        <div className="right">
          {title === "All Units" && (
            <div className="definition">
              A unit’s (a collection of rooms) compliance is calculated from
              visits to all rooms on that unit by any hospital staff.
            </div>
          )}
          {title === "All Departments" && (
            <div className="definition">
              A department’s (a collection of staff) compliance is calculated
              from its staff’s visits to any patient room.
            </div>
          )}
          {entityType === "unit" && (
            <div className="help">
              Unit
              <HelpTooltip>
                Units are a collection of rooms in close proximity to each
                other. A unit’s compliance is calculated from visits to all
                rooms on that unit by any hospital staff.
              </HelpTooltip>
            </div>
          )}
          {entityType === "department" && (
            <div className="help">
              Department
              <HelpTooltip>
                A department is a collection of staff that share a management
                structure. A department’s compliance is calculated from its
                staff’s visits to any room.
              </HelpTooltip>
            </div>
          )}
          {title ? null : (
            <ResourceBannerCompliance
              {...{ compliance, opportunities, bsrCompliance }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

ResourceBanner.propTypes = {
  entityType: PropTypes.string,
  entityName: PropTypes.string,
  compliance: PropTypes.number,
  opportunities: PropTypes.number,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  detailEntities: PropTypes.array,
}

ResourceBanner.defaultProps = {
  detailEntities: [],
}

export default ResourceBanner
